<template>
  <div>
    <el-dialog
      id="editDialog"
      :title="orderId ? '修改销售单' : '新增销售单'"
      :visible="true"
      @close="close(false)"
      width="1000px"
    >
      <el-form
        :model="headInfo"
        label-position="right"
        label-width="110px"
        ref="editOrderFormRef"
        :rules="{
          orderDate: this.$ruleUtil.simple({
            fieldName: '单据日期',
            handleType: '选择',
            required: true,
          }),
          customerId: this.$ruleUtil.simple({
            fieldName: '客户',
            handleType: '选择',
            required: true,
          }),
          customerName: this.$ruleUtil.simple({
            fieldName: '联系人姓名',
            required: true,
            max: 50,
          }),
          customerPhoneNumber: this.$ruleUtil.simple({
            fieldName: '联系方式',
            required: true,
            max: 20,
          }),
          customerAddress: this.$ruleUtil.simple({
            fieldName: '联系地址',
            required: true,
            max: 20,
          }),
          paperOrderSysFileIdList: this.$ruleUtil.array(
            '纸质单据',
            '上传',
            this.orderConfig.collectOrderPaperOrderRequired ? 1 : 0,
            10
          ),
          collectVoucherSysFileIdList: this.$ruleUtil.array(
            '收款凭证',
            '上传',
            orderConfig.collectOrderCollectVoucherRequired ? 1 : 0,
            10
          ),
          saleUserIdList: this.$ruleUtil.array('业务员', '选择', 1),
          totalQuantity: this.$ruleUtil.number(
            '所选商品数量',
            this.quantityMinLimit,
            1000
          ),
        }"
        v-if="headInfo"
      >
        <el-form-item label="单号" v-if="headInfo.id">
          <span v-fmtype="headInfo.orderNo ? null : 'info'">{{
            headInfo.orderNo || "草稿"
          }}</span>
          <el-tag
            class="fm-ml-5"
            :type="
              $jsTool.getOrderApprovalStatusType(
                headInfo.orderApprovalStatusEnum
              )
            "
            >{{ headInfo.orderApprovalStatusEnum.Desc }}</el-tag
          >
        </el-form-item>
        <el-form-item label="单据日期" prop="orderDate">
          <el-date-picker
            v-model="headInfo.orderDate"
            type="date"
            format="yyyy-MM-dd"
            value-format="yyyy-MM-dd"
            placeholder="选择单据日期"
          >
          </el-date-picker>
        </el-form-item>
        <el-form-item label="客户" prop="customerId">
          <CustomerSelect
            :value="customer"
            @select="selectCustomer"
          ></CustomerSelect>
        </el-form-item>
        <el-row :gutter="10" v-if="headInfo.customerId">
          <el-col :span="6">
            <el-form-item label="联系人信息" prop="customerId">
              <el-input
                v-model="headInfo.customerName"
                placeholder="请输入联系人姓名"
                :disabled="!orderConfig.editCustomer"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label-width="10" prop="customerId">
              <el-input
                v-model="headInfo.customerPhoneNumber"
                placeholder="请输入联系方式"
                :disabled="!orderConfig.editCustomer"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label-width="10" prop="customerId">
              <el-input
                v-model="headInfo.customerAddress"
                placeholder="请输入联系地址"
                :disabled="!orderConfig.editCustomer"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-form-item label="所选商品" prop="totalQuantity">
          <div class="fm-flex">
            <p
              v-fmtype="'success'"
              v-if="headInfo.totalQuantity && headInfo.totalQuantity > 0"
            >
              {{ "共 " + headInfo.totalQuantity + " 件商品" }}
            </p>
            <span v-fmtype="'error'" v-else>未选择商品</span>
            <span>，总零售价：</span>
            <FmAmount :amount="headInfo.commodityBuyingTotalAmount"></FmAmount>
            <el-button
              class="fm-ml-15"
              type="primary"
              plain
              size="mini"
              icon="el-icon-plus"
              @click="showSelectCommodityDialog"
              >选择商品</el-button
            >
          </div>
        </el-form-item>
        <el-table
          :data="itemList || []"
          stripe
          :row-key="
            (row) => {
              return row.itemNo + row.commoditySpecId;
            }
          "
          max-height="500px"
          :span-method="objectSpanMethod"
          style="width: 100%"
        >
          <!-- <el-table-column
            prop="itemNo"
            label="序号"
            width="50"
            align="center"
            header-align="center"
            fixed="left"
            show-overflow-tooltip
          >
          </el-table-column> -->
          <el-table-column
            label="商品图片"
            width="100"
            align="center"
            header-align="center"
          >
            <template slot-scope="scope">
              <CommodityImage
                :commodity="scope.row.commodity"
                v-if="scope.row.saleSuitId"
              ></CommodityImage>
              <CommodityImage
                :commodity="scope.row.commodity"
                :commoditySpec="scope.row.commoditySpec"
                v-else
              ></CommodityImage>
            </template>
          </el-table-column>
          <el-table-column
            prop="saleSuitName"
            label="套装 / 商品信息"
            min-width="250"
            align="left"
            header-align="center"
            show-overflow-tooltip
          >
            <template slot-scope="scope">
              <div style="line-height: 1.4em">
                <div style="font-size: 1.1em">
                  {{ scope.row.commodity.name }}
                </div>
                <div style="font-size: 1.1em" v-if="scope.row.saleSuitId">
                  {{ "套装名称：" + scope.row.saleSuitName }}
                </div>
                <div class="fm-mt-5">
                  {{ "分类：" + scope.row.commodity.commodityCategory.name }}
                </div>
                <div>{{ "颜色：" + scope.row.commodity.color }}<br /></div>
                <div>{{ "单位：" + scope.row.commodity.unit }}<br /></div>
              </div>
            </template>
          </el-table-column>
          <el-table-column
            prop="commoditySpec.specName"
            label="套装内容/规格名称"
            min-width="180"
            align="left"
            header-align="center"
          >
            <template slot-scope="scope">
              <div v-if="scope.row.saleSuitId">
                <div
                  v-for="(item, index) in itemList
                    .filter(
                      (d) =>
                        d.saleSuitId && d.saleSuitId == scope.row.saleSuitId
                    )
                    .map(
                      (f) =>
                        f.commoditySpec.specName +
                        ' x ' +
                        f.saleSuitItemQuantity
                    )"
                  :key="index"
                >
                  {{ item }}
                </div>
                <div class="fm-flex">
                  套装内规格零售价：<FmAmount
                    :amount="
                      $jsTool.sum(
                        itemList
                          .filter(
                            (d) =>
                              d.saleSuitId &&
                              d.saleSuitId == scope.row.saleSuitId
                          )
                          .map((d) => d.buyingPrice)
                      )
                    "
                  ></FmAmount>
                </div>
              </div>
              <div class="fm-line-3" v-else>
                {{ scope.row.commoditySpec.specName }}
              </div>
            </template>
          </el-table-column>
          <el-table-column
            prop="buyingPrice"
            label="套装/规格零售价"
            width="180"
            align="center"
            header-align="center"
          >
            <template slot-scope="scope">
              <el-input-number
                style="width: 170px"
                v-model="scope.row.buyingPrice"
                size="small"
                :precision="2"
                :min="0"
                :step="1"
                @change="changeItemPrice(scope.$index, scope.row)"
                v-if="!scope.row.saleSuitId"
              ></el-input-number>
              <el-input-number
                style="width: 170px"
                v-model="scope.row.saleSuitSalePrice"
                size="small"
                :precision="2"
                :min="0"
                :step="1"
                @change="changeItemPrice(scope.$index, scope.row)"
                v-else
              ></el-input-number>
              <div v-if="scope.row.tips">
                <p v-fmtype="'warning'" style="text-align: left">
                  {{ scope.row.tips }}
                </p>
              </div>
            </template>
          </el-table-column>
          <el-table-column
            prop="itemQuantity"
            label="购买数量"
            width="150"
            align="center"
            header-align="center"
          >
            <template slot-scope="scope">
              <CommodityQuantityInputBox
                :key="
                  'itemQuantityInputNumber' + scope.$index + itemQuantityKey
                "
                :value="scope.row.itemQuantity"
                size="small"
                :max="
                  scope.row.commoditySpec &&
                  !scope.row.commoditySpec.inProduction
                    ? scope.row.commoditySpec.availableQuantity
                    : 1000
                "
                @change="
                  (e) => {
                    changeItemQuantity(scope.$index, scope.row, e);
                  }
                "
                v-if="!scope.row.saleSuitId"
              ></CommodityQuantityInputBox>
              <CommodityQuantityInputBox
                :key="
                  'saleSuitQuantityInputNumber' + scope.$index + itemQuantityKey
                "
                :value="scope.row.saleSuitQuantity"
                size="small"
                @change="
                  (e) => {
                    changeItemQuantity(scope.$index, scope.row, e);
                  }
                "
                v-else
              ></CommodityQuantityInputBox>
            </template>
          </el-table-column>
          <el-table-column
            prop="commodityBuyingTotalAmount"
            label="总零售价"
            width="120"
            align="center"
            header-align="center"
          >
            <template slot-scope="scope">
              <FmAmount
                :amount="
                  scope.row.saleSuitId
                    ? scope.row.saleSuitSumAmount
                    : scope.row.commodityBuyingTotalAmount
                "
              ></FmAmount>
            </template>
          </el-table-column>
          <el-table-column
            prop="disCountAmount"
            label="折扣金额"
            width="120"
            align="center"
            header-align="center"
          >
            <template slot-scope="scope">
              <FmAmount
                :amount="
                  scope.row.saleSuitId
                    ? scope.row.saleSuitDisCountAmount
                    : scope.row.disCountAmount
                "
              ></FmAmount>
            </template>
          </el-table-column>
          <el-table-column
            prop="itemAmount"
            label="成交价"
            width="200"
            align="center"
            header-align="center"
          >
            <template slot-scope="scope">
              <el-input-number
                style="width: 170px"
                v-model="scope.row.itemAmount"
                size="small"
                :precision="2"
                :min="0"
                :max="
                  typeof scope.row.commodityBuyingTotalAmount == 'string'
                    ? Number(scope.row.commodityBuyingTotalAmount)
                    : scope.row.commodityBuyingTotalAmount
                "
                :step="1"
                @change="changeItemAmount(scope.$index, scope.row)"
                v-if="!scope.row.saleSuitId"
              ></el-input-number>
              <el-input-number
                style="width: 170px"
                v-model="scope.row.saleSuitAmount"
                size="small"
                :precision="2"
                :min="0"
                :max="
                  typeof scope.row.saleSuitSumAmount == 'string'
                    ? Number(scope.row.saleSuitSumAmount)
                    : scope.row.saleSuitSumAmount
                "
                :step="1"
                @change="changeItemAmount(scope.$index, scope.row)"
                v-else
              ></el-input-number>
            </template>
          </el-table-column>
        </el-table>
        <el-form-item label="优惠金额" prop="disCountAmount" class="fm-mt-10">
          <div class="fm-flex">
            <FmAmount :amount="headInfo.disCountAmount"></FmAmount>
            <span>（套装优惠金额：</span>
            <FmAmount
              :amount="
                $jsTool.sum(
                  $jsTool
                    .groupByV(
                      itemList.filter((d) => d.saleSuitId) || [],
                      'saleSuitId'
                    )
                    .map((d) =>
                      $jsTool.sub(
                        $jsTool.sum(d.map((d) => d.commodityBuyingTotalAmount)),
                        d[0].saleSuitAmount
                      )
                    )
                )
              "
            ></FmAmount>
            <span>，规格优惠金额：</span>
            <FmAmount
              :amount="
                $jsTool.sum(
                  itemList
                    .filter((d) => !d.saleSuitId)
                    .map((f) => f.disCountAmount)
                )
              "
            ></FmAmount>
            <span>）</span>
          </div>
        </el-form-item>
        <el-form-item label="商品零售成交价" prop="commodityBuyingAmount">
          <el-input-number
            v-model="headInfo.commodityBuyingAmount"
            size="small"
            :precision="2"
            :min="0"
            :max="maxCommodityBuyingAmount"
            :step="1"
            style="width: 180px"
            @change="changeCommodityBuyingAmount"
          ></el-input-number>
        </el-form-item>
        <el-form-item label="其他费用">
          <div class="fm-flex">
            <el-switch
              v-model="hasOtherExpenseAmount"
              :active-color="$jsTool.getColor('success')"
              :inactive-color="$jsTool.getColor('warning')"
              @change="handleHasOtherExpenseAmount"
            >
            </el-switch>
            <p
              v-fmtype="'success'"
              class="fm-ml-10"
              v-if="hasOtherExpenseAmount"
            >
              有其他费用
            </p>
            <span v-fmtype="'warning'" class="fm-ml-10" v-else>无其他费用</span>
            <p class="fm-ml-10" v-if="hasOtherExpenseAmount">其他费用合计：</p>
            <FmAmount
              :amount="headInfo.otherExpenseAmount"
              v-if="hasOtherExpenseAmount"
            ></FmAmount>
          </div>
        </el-form-item>
        <el-form-item label="" v-if="hasOtherExpenseAmount">
          <el-table
            :data="headInfo.orderOtherExpenseAddNewPojoList || []"
            stripe
            :row-key="
              (row) => {
                return row.itemNo;
              }
            "
            :key="'otherExpenseAmount' + otherExpenseAmountKey"
            max-height="250px"
            style="width: 100%"
          >
            <el-table-column
              prop="itemNo"
              label="序号"
              width="50"
              align="center"
              header-align="center"
              fixed="left"
              show-overflow-tooltip
            >
            </el-table-column>
            <el-table-column
              prop="name"
              label="名称"
              min-width="200"
              align="center"
              header-align="center"
              show-overflow-tooltip
            >
              <template slot-scope="scope">
                <el-input
                  v-model="scope.row.name"
                  maxlength="20"
                  show-word-limit
                  placeholder="请输入金额说明"
                ></el-input>
              </template>
            </el-table-column>
            <el-table-column
              prop="itemAmount"
              label="金额"
              min-width="200"
              align="center"
              header-align="center"
              show-overflow-tooltip
            >
              <template slot-scope="scope">
                <el-input-number
                  v-model="scope.row.itemAmount"
                  size="small"
                  :precision="2"
                  :min="0"
                  :step="1"
                  style="width: 180px"
                  @change="
                    itemOrderOtherExpenseAmountChange(scope.$index, scope.row)
                  "
                ></el-input-number>
              </template>
            </el-table-column>
            <el-table-column
              fixed="right"
              label="操作"
              header-align="center"
              align="center"
              width="150"
            >
              <template slot-scope="scope">
                <el-button
                  @click.native.stop="addOrderOtherExpenseItem(scope.$index)"
                  type="text"
                  icon="el-icon-plus"
                >
                  增加
                </el-button>
                <el-popconfirm
                  title="是否删除所选其他费用？"
                  :disabled="
                    headInfo.orderOtherExpenseAddNewPojoList.length == 1
                  "
                  @confirm="deleteOrderOtherExpenseItem(scope.$index)"
                >
                  <el-button
                    slot="reference"
                    type="text"
                    icon="el-icon-delete"
                    v-fmtype="
                      headInfo.orderOtherExpenseAddNewPojoList.length == 1
                        ? 'info'
                        : 'error'
                    "
                    :disabled="
                      headInfo.orderOtherExpenseAddNewPojoList.length == 1
                    "
                    @click.native.stop
                  >
                    删除
                  </el-button>
                </el-popconfirm>
              </template>
            </el-table-column>
          </el-table>
        </el-form-item>

        <el-form-item label="单据金额" prop="orderAmount">
          <div class="fm-flex" style="height: 32px">
            <span>
              <FmAmount :amount="headInfo.orderAmount"></FmAmount>
            </span>
          </div>
        </el-form-item>

        <el-form-item label="现结金额" class="fm-mt-10">
          <el-tooltip
            slot="label"
            effect="dark"
            content=""
            placement="top-start"
          >
            <div slot="content" style="line-height: 1.5em">
              <div style="font-weight: bold">现结金额说明</div>
              现结金额为制单时已经收款的金额，填写时不得大于销售单的单据金额<br />销售单审批通过后，自动根据已填写的现结信息生成收款单并自动审批通过
            </div>
            <div>
              <i class="el-icon el-icon-question fm-mr-5"></i>
              <span>现结金额</span>
            </div>
          </el-tooltip>
          <div class="fm-flex">
            <el-switch
              v-model="hasSettledAmount"
              :active-color="$jsTool.getColor('success')"
              :inactive-color="$jsTool.getColor('warning')"
              @change="handleHasSettledAmount"
            >
            </el-switch>
            <p v-fmtype="'success'" class="fm-ml-10" v-if="hasSettledAmount">
              有现结金额
            </p>
            <span v-fmtype="'warning'" class="fm-ml-10" v-else>无现结金额</span>
            <p class="fm-ml-10" v-if="hasSettledAmount">现结金额合计：</p>
            <FmAmount
              :amount="headInfo.settledAmount"
              v-if="hasSettledAmount"
            ></FmAmount>
          </div>
        </el-form-item>
        <el-form-item label="" v-if="hasSettledAmount">
          <el-table
            :data="headInfo.fundAccountAddNewPojoList || []"
            stripe
            :row-key="
              (row) => {
                return row.itemNo;
              }
            "
            :key="'settledAmount' + settledAmountKey"
            max-height="250px"
            style="width: 100%"
          >
            <el-table-column
              prop="itemNo"
              label="序号"
              width="50"
              align="center"
              header-align="center"
              fixed="left"
              show-overflow-tooltip
            >
            </el-table-column>
            <el-table-column
              prop="name"
              label="资金账户"
              min-width="200"
              align="center"
              header-align="center"
              show-overflow-tooltip
            >
              <template slot-scope="scope">
                <FundAccountSelect
                  :value="scope.row.fundAccount"
                  @select="
                    (e) => {
                      selectFundAccount(e, scope.$index);
                    }
                  "
                ></FundAccountSelect>
              </template>
            </el-table-column>
            <el-table-column
              prop="itemAmount"
              label="金额"
              min-width="200"
              align="center"
              header-align="center"
              show-overflow-tooltip
            >
              <template slot-scope="scope">
                <el-input-number
                  v-model="scope.row.itemAmount"
                  size="small"
                  :precision="2"
                  :min="0"
                  :step="1"
                  style="width: 180px"
                  @change="itemFundAccountAmountChange(scope.$index, scope.row)"
                ></el-input-number>
              </template>
            </el-table-column>
            <el-table-column
              fixed="right"
              label="操作"
              header-align="center"
              align="center"
              width="150"
            >
              <template slot-scope="scope">
                <el-button
                  @click.native.stop="addFundAccountItem(scope.$index)"
                  type="text"
                  icon="el-icon-plus"
                >
                  增加
                </el-button>
                <el-popconfirm
                  title="是否删除所选现结金额？"
                  :disabled="headInfo.fundAccountAddNewPojoList.length == 1"
                  @confirm="deleteFundAccountItem(scope.$index)"
                >
                  <el-button
                    slot="reference"
                    type="text"
                    icon="el-icon-delete"
                    v-fmtype="
                      headInfo.fundAccountAddNewPojoList.length == 1
                        ? 'info'
                        : 'error'
                    "
                    :disabled="headInfo.fundAccountAddNewPojoList.length == 1"
                    @click.native.stop
                  >
                    删除
                  </el-button>
                </el-popconfirm>
              </template>
            </el-table-column>
          </el-table>
        </el-form-item>
        <el-form-item
          label="纸质单据"
          class="fm-mt-10"
          prop="paperOrderSysFileIdList"
          key="paperOrderSysFileIdList"
          v-if="hasSettledAmount"
        >
          <div
            class="fm-rela fm-uploadDiv-100"
            v-for="(file, index) in paperOrderImageList"
            :key="index"
          >
            <el-image
              :id="'paperImage' + index"
              :src="file.url"
              :preview-src-list="paperOrderImageList.map((d) => d.url)"
              :initial-index="index"
              alt=""
            />
            <div class="LoadingIcon fm-center" v-if="file.status == 'ready'">
              <i class="LoadingIcon-icon el-icon el-icon-loading"></i>
            </div>
            <div class="HandleIcon">
              <i
                @click="paperOrderImagePreview(index)"
                alt="预览图片"
                class="HandleIcon-icon fm-center HandleIcon-previewIcon el-icon el-icon-view"
              ></i>
              <i
                alt="删除图片"
                @click="paperOrderImageDelete(index, file)"
                class="HandleIcon-icon fm-center HandleIcon-deleteIcon el-icon el-icon-delete"
              ></i>
            </div>
          </div>
          <el-upload
            :action="$envConfig.VUE_APP_uploadSaleOrderPaperOrder + ''"
            :headers="{
              AuthorityToken: $storageUtil.getAuthorityToken(),
            }"
            :limit="10"
            multiple
            accept="image/*"
            :file-list="paperOrderImageList"
            :show-file-list="false"
            :on-change="paperOrderImageChange"
            :on-success="paperOrderImageSuccess"
            :on-exceed="() => this.$message.warning('最多上传10张图片')"
            v-if="paperOrderImageList.length < 10"
          >
            <div slot="default" class="fm-center fm-uploadDiv-100">
              <i class="el-icon-plus"></i>
            </div>
          </el-upload>
        </el-form-item>
        <el-form-item
          label="收款凭证"
          class="fm-mt-10"
          prop="collectVoucherSysFileIdList"
          v-if="hasSettledAmount"
        >
          <div
            class="fm-rela fm-uploadDiv-100"
            v-for="(file, index) in collectVoucherFileList"
            :key="index"
          >
            <el-image
              :id="'collectVoucherImage' + index"
              :src="file.url"
              :preview-src-list="collectVoucherFileList.map((d) => d.url)"
              :initial-index="index"
              alt=""
            />
            <div class="LoadingIcon fm-center" v-if="file.status == 'ready'">
              <i class="LoadingIcon-icon el-icon el-icon-loading"></i>
            </div>
            <div class="HandleIcon">
              <i
                @click="collectVoucherFilePreview(index)"
                alt="预览图片"
                class="HandleIcon-icon fm-center HandleIcon-previewIcon el-icon el-icon-view"
              ></i>
              <i
                alt="删除图片"
                @click="collectVoucherFileDelete(index, file)"
                class="HandleIcon-icon fm-center HandleIcon-deleteIcon el-icon el-icon-delete"
              ></i>
            </div>
          </div>
          <el-upload
            :action="$envConfig.VUE_APP_uploadSaleOrderCollectVoucher + ''"
            :headers="{
              AuthorityToken: $storageUtil.getAuthorityToken(),
            }"
            :limit="10"
            multiple
            accept="image/*"
            :file-list="collectVoucherFileList"
            :show-file-list="false"
            :on-change="collectVoucherFileChange"
            :on-success="collectVoucherFileSuccess"
            :on-exceed="() => this.$message.warning('最多上传10张图片')"
            v-if="collectVoucherFileList.length < 10"
          >
            <div slot="default" class="fm-center fm-uploadDiv-100">
              <i class="el-icon-plus"></i>
            </div>
          </el-upload>
        </el-form-item>
        <el-form-item
          label="收款备注"
          prop="collectRemark"
          v-if="hasSettledAmount"
        >
          <el-input
            type="textarea"
            :autosize="{ minRows: 3, maxRows: 6 }"
            maxlength="200"
            show-word-limit
            v-model="headInfo.collectRemark"
            style="width: 400px"
            placeholder="请输入收款备注信息"
          ></el-input>
        </el-form-item>
        <el-form-item label="其他成本" class="fm-mt-10">
          <div class="fm-flex">
            <el-switch
              v-model="hasOtherCostAmount"
              :active-color="$jsTool.getColor('success')"
              :inactive-color="$jsTool.getColor('warning')"
              @change="handleHasOtherCostAmount"
            >
            </el-switch>
            <p v-fmtype="'success'" class="fm-ml-10" v-if="hasOtherCostAmount">
              有其他成本
            </p>
            <span v-fmtype="'warning'" class="fm-ml-10" v-else>无其他成本</span>
            <p class="fm-ml-10" v-if="hasOtherCostAmount">其他成本合计：</p>
            <FmAmount
              :amount="headInfo.otherCostAmount"
              v-if="hasOtherCostAmount"
            ></FmAmount>
          </div>
        </el-form-item>
        <el-form-item label="" v-if="hasOtherCostAmount">
          <el-table
            :data="headInfo.orderOtherCostAddNewPojoList || []"
            stripe
            :row-key="
              (row) => {
                return row.itemNo;
              }
            "
            :key="'otherCostAmount' + otherCostAmountKey"
            max-height="250px"
            style="width: 100%"
          >
            <el-table-column
              prop="itemNo"
              label="序号"
              width="50"
              align="center"
              header-align="center"
              fixed="left"
              show-overflow-tooltip
            >
            </el-table-column>
            <el-table-column
              prop="name"
              label="名称"
              min-width="200"
              align="center"
              header-align="center"
              show-overflow-tooltip
            >
              <template slot-scope="scope">
                <el-input
                  v-model="scope.row.name"
                  maxlength="20"
                  show-word-limit
                  placeholder="请输入金额说明"
                ></el-input>
              </template>
            </el-table-column>
            <el-table-column
              prop="itemAmount"
              label="金额"
              min-width="200"
              align="center"
              header-align="center"
              show-overflow-tooltip
            >
              <template slot-scope="scope">
                <el-input-number
                  v-model="scope.row.itemAmount"
                  size="small"
                  :precision="2"
                  :min="0"
                  :step="1"
                  style="width: 180px"
                  @change="
                    itemOrderOtherCostAmountChange(scope.$index, scope.row)
                  "
                ></el-input-number>
              </template>
            </el-table-column>
            <el-table-column
              fixed="right"
              label="操作"
              header-align="center"
              align="center"
              width="150"
            >
              <template slot-scope="scope">
                <el-button
                  @click.native.stop="addOrderOtherCostItem(scope.$index)"
                  type="text"
                  icon="el-icon-plus"
                >
                  增加
                </el-button>
                <el-popconfirm
                  title="是否删除所选其他成本？"
                  :disabled="headInfo.orderOtherCostAddNewPojoList.length == 1"
                  @confirm="deleteOrderOtherCostItem(scope.$index)"
                >
                  <el-button
                    slot="reference"
                    type="text"
                    icon="el-icon-delete"
                    v-fmtype="
                      headInfo.orderOtherCostAddNewPojoList.length == 1
                        ? 'info'
                        : 'error'
                    "
                    :disabled="
                      headInfo.orderOtherCostAddNewPojoList.length == 1
                    "
                    @click.native.stop
                  >
                    删除
                  </el-button>
                </el-popconfirm>
              </template>
            </el-table-column>
          </el-table>
        </el-form-item>
        <div v-if="headInfo.extFieldValueAddNewPojoList.length > 0">
          <div style="height: 10px"></div>
          <el-divider content-position="left">
            <span style="font-weight: bold">拓展字段</span>
          </el-divider>
          <div style="height: 20px"></div>
          <el-row
            v-for="(rowItem, rowFiIndex) in $jsTool.groupArray(
              headInfo.extFieldValueAddNewPojoList,
              3
            )"
            :key="rowFiIndex"
          >
            <el-col :span="8" v-for="(item, fiIndex) in rowItem" :key="fiIndex">
              <el-form-item
                :class="item.visible ? '' : 'deleteFormItem'"
                :label="item.label"
                :required="item.requiredMark && item.visible"
                style="margin-bottom: 10px"
              >
                <span
                  style="color: var(--fm-warning-color)"
                  v-if="!item.visible"
                  >已删除</span
                >
                <template v-else>
                  <template v-if="item.extFieldTypeEnum == 'Input'">
                    <el-input
                      type="text"
                      :placeholder="item.configObj.placeholder"
                      :maxlength="item.configObj.maxlength"
                      v-model="item.value"
                      show-word-limit
                      style="width: 200px"
                    >
                    </el-input>
                  </template>
                  <template v-if="item.extFieldTypeEnum == 'InputNumber'">
                    <el-input-number
                      inputWidth="100"
                      v-model="item.value"
                      :placeholder="item.configObj.placeholder"
                      :max="item.configObj.max"
                      :min="item.configObj.min"
                      :step="item.configObj.step"
                      :precision="item.configObj.precision"
                      style="width: 200px"
                    ></el-input-number>
                  </template>
                  <template v-if="item.extFieldTypeEnum == 'Radio'">
                    <el-radio-group v-model="item.value">
                      <el-radio
                        v-for="(check, index) in item.configObj.list"
                        :key="index"
                        :label="check.label"
                        :name="check.label"
                        style="height: 32px; align-content: space-around"
                      ></el-radio>
                    </el-radio-group>
                  </template>
                  <template v-if="item.extFieldTypeEnum == 'Checkbox'">
                    <el-checkbox-group v-model="item.value">
                      <el-checkbox
                        v-for="(check, index) in item.configObj.list"
                        :key="index"
                        :label="check.label"
                        :name="check.label"
                      ></el-checkbox>
                    </el-checkbox-group>
                  </template>
                  <template v-if="item.extFieldTypeEnum == 'Select'">
                    <el-select
                      v-model="item.value"
                      :placeholder="item.configObj.placeholder"
                    >
                      <el-option
                        v-for="option in item.configObj.list"
                        :key="option.no"
                        :label="option.label"
                        :value="option.label"
                      >
                      </el-option>
                    </el-select>
                  </template>
                  <template v-if="item.extFieldTypeEnum == 'TimePicker'">
                    <el-date-picker
                      v-model="item.value"
                      :type="item.configObj.format"
                      :value-format="
                        item.configObj.format == 'datetime'
                          ? 'yyyy-MM-dd HH:mm:ss'
                          : 'yyyy-MM-dd'
                      "
                      style="width: 200px"
                    >
                    </el-date-picker>
                  </template>
                </template>
              </el-form-item>
            </el-col>
          </el-row>
          <el-divider></el-divider>
        </div>

        <el-form-item label="业务员" prop="saleUserIdList">
          <UserTransfer
            v-model="headInfo.saleUserIdList"
            :userList="saleUserList"
            @addUser="addSaleUser"
            @cancelUser="cancelSaleUser"
          ></UserTransfer>
        </el-form-item>
        <el-form-item label="备注" prop="remark">
          <el-input
            type="textarea"
            :autosize="{ minRows: 3, maxRows: 6 }"
            maxlength="200"
            show-word-limit
            v-model="headInfo.remark"
            style="width: 400px"
            placeholder="请输入备注信息"
          ></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="close(false)">取 消</el-button>
        <el-button type="primary" @click="edit(false)"> 保存至草稿 </el-button>
        <el-popconfirm
          icon="el-icon-info"
          :icon-color="$jsTool.getColor('warning')"
          :title="
            orderConfig.needApproval
              ? '是否将单据提交审批？'
              : '当前单据提交后将自动审批通过，请确认单据信息无误，是否继续提交？'
          "
          @confirm="edit(true)"
        >
          <el-button slot="reference" type="success" @click.native.stop>
            保存并提交
          </el-button>
        </el-popconfirm>
      </div>
    </el-dialog>
    <CommoditySelectDialog
      :show="commoditySelectDialogShow"
      from="SaleOrder"
      :selectList="itemList"
      @selectCommodity="
        (itemList) => {
          selectCommodity(itemList, true);
        }
      "
      @close="commoditySelectDialogShow = false"
      v-if="commoditySelectDialogShow"
    ></CommoditySelectDialog>
  </div>
</template>

<script>
export default {
  name: "Fmerpv2WebSaleOrderEditDialog",
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    orderId: {
      type: String,
      default: null,
    },
  },
  watch: {
    show: {
      handler(newVal) {
        if (newVal) {
          setTimeout(async () => {
            Object.assign(this.$data, this.$options.data());
            this.$nextTick(() => {
              this.$refs.editOrderFormRef.clearValidate();
            });
            await this.getExtFieldList();
            this.initOrderData();
            this.getOrderConfig();
            this.quantityMinLimit = this.$jsTool.getTenantDecimalLength();
            if (this.orderId) {
              setTimeout(async () => {
                await this.getOrderInfo();
                this.$nextTick(() => {
                  this.$refs.editOrderFormRef.clearValidate();
                });
              }, 100);
            }
          }, 100);
        }
      },
      immediate: true,
    },
    // orderId: {
    //   handler(newVal) {
    //     if (newVal) {
    //       setTimeout(() => {
    //         this.getOrderInfo();
    //       }, 100);
    //     }
    //   },
    //   immediate: true,
    // },
  },
  computed: {
    maxCommodityBuyingAmount() {
      if (!this.itemList || this.itemList.length == 0) {
        return;
      }
      let hasSaleSuitList = this.itemList.filter((d) => d.saleSuitId);
      let noSaleSuitList = this.itemList.filter((d) => !d.saleSuitId);
      let amount = 0;
      if (hasSaleSuitList && hasSaleSuitList.length > 0) {
        amount = this.$jsTool.sum(
          this.$jsTool
            .groupByV(hasSaleSuitList, "saleSuitId")
            .map((d) => d[0].saleSuitSumAmount)
        );
      }
      if (noSaleSuitList && noSaleSuitList.length > 0) {
        amount = this.$jsTool.add(
          amount,
          this.$jsTool.sum(
            noSaleSuitList.map((d) => d.commodityBuyingTotalAmount)
          )
        );
      }
      return Number(amount);
    },
  },
  data() {
    return {
      orderConfig: {
        needApproval: true,
        editCustomer: false,
        collectOrderPaperOrderRequired: true,
        collectOrderCollectVoucherRequired: true,
      },

      hasOtherExpenseAmount: false,
      otherExpenseAmountKey: "null",

      hasSettledAmount: false,
      settledAmountKey: "null",

      hasOtherCostAmount: false,
      otherCostAmountKey: "null",

      itemQuantityKey: "null",

      headInfo: {
        orderApprovalStatusEnum: {},
        orderDate: null,
        customerId: null,
        customerName: null,
        customerPhoneNumber: null,
        customerAddress: "",
        saleUserIdList: [],
        relatedPreCollectOrderIdList: [],
        commodityBuyingTotalAmount: "0.00",
        disCountAmount: "0.00",
        orderAmount: "0.00",
        commodityBuyingAmount: "0.00",
        totalQuantity: 0,
        settledAmount: "0.00",
        fundAccountAddNewPojoList: [
          {
            itemNo: 1,
            fundAccountId: null,
            itemAmount: "0.00",
            remark: "",
          },
        ],
        paperOrderSysFileIdList: [],
        collectVoucherSysFileIdList: [],
        collectRemark: "",
        otherExpenseAmount: "0.00",
        orderOtherExpenseAddNewPojoList: [
          {
            itemNo: 1,
            name: null,
            itemAmount: "0.00",
          },
        ],
        otherCostAmount: "0.00",
        orderOtherCostAddNewPojoList: [
          {
            itemNo: 1,
            name: null,
            itemAmount: "0.00",
          },
        ],
        extFieldValueAddNewPojoList: [],
      },
      itemList: [],
      customer: {},
      saleUserList: [],
      relatedPreCollectOrderList: [],

      commoditySelectDialogShow: false,

      paperOrderImageList: [],
      collectVoucherFileList: [],

      quantityMinLimit: 0.001,

      // 拓展字段
      extFieldList: [],
    };
  },

  mounted() {},

  methods: {
    async getExtFieldList() {
      let res = await this.$api.extField_findAvailableList("SaleOrder");
      if (res && res.success) {
        this.extFieldList = this.$jsTool.handleExtFiledRes(res.data);
      }
    },

    async initOrderData() {
      let userInfo = await this.$storageUtil.getUserInfo();
      this.headInfo.orderDate = this.$moment(new Date()).format("yyyy-MM-DD");
      this.headInfo.saleUserIdList = [userInfo.id];
      this.saleUserList = [userInfo];
      this.headInfo.extFieldValueAddNewPojoList = JSON.parse(
        JSON.stringify(this.extFieldList || [])
      );
      this.$nextTick(() => {
        this.$refs.editOrderFormRef.clearValidate();
      });
    },
    async getOrderConfig() {
      let res = await this.$api.tenantPersonalConfig_findByCodeIn([
        "Order:SaleOrder:NeedApproval",
        "Order:SaleOrder:EditCustomer",
        "Order:FundCollectOrder:PaperOrderRequired",
        "Order:FundCollectOrder:CollectVoucherRequired",
      ]);
      if (res && res.success) {
        let needApprovalIndex = res.data.findIndex(
          (d) => d.code == "Order:SaleOrder:NeedApproval"
        );
        if (
          needApprovalIndex > -1 &&
          res.data[needApprovalIndex].value == "false"
        ) {
          this.orderConfig.needApproval = false;
        }
        let editCustomerIndex = res.data.findIndex(
          (d) => d.code == "Order:SaleOrder:EditCustomer"
        );
        if (
          editCustomerIndex > -1 &&
          res.data[editCustomerIndex].value == "true"
        ) {
          this.orderConfig.editCustomer = true;
        }
        let paperOrderRequiredIndex = res.data.findIndex(
          (d) => d.code == "Order:FundCollectOrder:PaperOrderRequired"
        );
        if (
          paperOrderRequiredIndex > -1 &&
          res.data[paperOrderRequiredIndex].value == "false"
        ) {
          this.orderConfig.collectOrderPaperOrderRequired = false;
        }
        let collectVoucherIndex = res.data.findIndex(
          (d) => d.code == "Order:FundCollectOrder:CollectVoucherRequired"
        );
        if (
          collectVoucherIndex > -1 &&
          res.data[collectVoucherIndex].value == "false"
        ) {
          this.orderConfig.collectOrderCollectVoucherRequired = false;
        }
      }
      this.$nextTick(() => {
        this.$refs.editOrderFormRef.clearValidate();
      });
    },
    objectSpanMethod({ row, column, rowIndex, columnIndex }) {
      if (
        (columnIndex == 0 ||
          columnIndex == 1 ||
          columnIndex == 2 ||
          columnIndex == 3 ||
          columnIndex == 4 ||
          columnIndex == 5 ||
          columnIndex == 6 ||
          columnIndex == 7) &&
        row.saleSuitId
      ) {
        let list = this.itemList
          .filter((d) => d.saleSuitId && d.saleSuitId == row.saleSuitId)
          .sort((a, b) => {
            return a.itemNo - b.itemNo;
          });
        if (list[0].itemNo == row.itemNo) {
          return {
            rowspan: list.length,
            colspan: 1,
          };
        } else {
          return {
            rowspan: 0,
            colspan: 0,
          };
        }
      }
      return {
        rowspan: 1,
        colspan: 1,
      };
    },

    selectCustomer(item) {
      this.headInfo.customerId = item.id;
      this.headInfo.customerName = item.name;
      this.headInfo.customerPhoneNumber = item.phoneNumber;
      this.headInfo.customerAddress = item.address;
      this.customer = item;
      this.selectPreCollectOrder([]);
      this.$message({
        message: "已自动更新联系人信息",
        type: "success",
      });
      this.selectCommodity(this.itemList, true);
    },

    selectFundAccount(item, index) {
      this.headInfo.fundAccountAddNewPojoList.splice(index, 1, {
        ...this.headInfo.fundAccountAddNewPojoList[index],
        fundAccount: item,
        fundAccountId: item.id,
      });
      this.settledAmountKey = Math.random();
    },

    // 选择商品相关
    showSelectCommodityDialog() {
      this.commoditySelectDialogShow = true;
    },
    async selectCommodity(list, getLastBuyingPrice) {
      list.forEach((item, index) => {
        item.itemNo = index + 1; // 索引从 0 开始，所以 itemNo 从 1 开始
      });
      if (list && this.headInfo.customerId && getLastBuyingPrice) {
        let commoditySpecIdList = list.filter((d) => !d.saleSuitId);
        if (commoditySpecIdList && commoditySpecIdList.length > 0) {
          let getLastBuyingPriceRes =
            await this.$api.saleOrder_getLastBuyingPrice({
              customerId: this.headInfo.customerId,
              commoditySpecIdList: commoditySpecIdList.map(
                (d) => d.commoditySpecId
              ),
            });
          if (getLastBuyingPriceRes && getLastBuyingPriceRes.success) {
            let resList = getLastBuyingPriceRes.data;
            list = list.map((d) => {
              let index = resList.findIndex(
                (f) => (f.commoditySpecId = d.commoditySpecId)
              );
              if (index > -1) {
                let lastBuyingPrice = resList[index].lastBuyingPrice;
                let originalBuyingPrice = d.commoditySpec.buyingPrice;
                return {
                  ...d,
                  buyingPrice: lastBuyingPrice,
                  commodityBuyingTotalAmount: this.$jsTool.multi(
                    lastBuyingPrice,
                    d.itemQuantity
                  ),
                  disCountAmount: 0,
                  itemAmount: this.$jsTool.multi(
                    lastBuyingPrice,
                    d.itemQuantity
                  ),
                  originalBuyingPrice: originalBuyingPrice,
                  lastBuyingPrice: lastBuyingPrice,
                  tips:
                    originalBuyingPrice != lastBuyingPrice
                      ? "原零售价" +
                        Number(originalBuyingPrice).toFixed(2) +
                        ",客户上次购买价" +
                        Number(lastBuyingPrice).toFixed(2)
                      : "",
                };
              } else {
                return d;
              }
            });
          }
        }
      }
      this.itemList = list;
      // 带销售套装的分组计算，避免重复
      let commodityBuyingAmount = "0.00";
      let saleSuitList = list.filter((d) => d.saleSuitId);
      if (saleSuitList && saleSuitList.length > 0) {
        let groupRes = this.$jsTool.groupByV(saleSuitList, "saleSuitId");
        commodityBuyingAmount = this.$jsTool.sum(
          groupRes.map((d) => d[0].saleSuitAmount)
        );
      }
      let specList = list.filter((d) => !d.saleSuitId);
      if (specList && specList.length > 0) {
        commodityBuyingAmount = this.$jsTool.add(
          commodityBuyingAmount,
          this.$jsTool.sum(specList.map((d) => d.itemAmount))
        );
      }
      this.headInfo.commodityBuyingAmount = commodityBuyingAmount;
      this.headInfo.commodityBuyingTotalAmount = this.$jsTool.add(
        this.$jsTool.sum(list.map((d) => d.commodityBuyingTotalAmount)),
        this.headInfo.otherExpenseAmount
      );
      this.headInfo.orderAmount = this.$jsTool.add(
        commodityBuyingAmount,
        this.headInfo.otherExpenseAmount
      );
      this.headInfo.disCountAmount = this.$jsTool.sub(
        this.$jsTool.sub(
          this.headInfo.commodityBuyingTotalAmount,
          this.headInfo.otherExpenseAmount
        ),
        this.headInfo.commodityBuyingAmount
      );
      this.headInfo.totalQuantity = Number(
        this.$jsTool.sumQuantity(list.map((d) => d.itemQuantity))
      );
      this.commoditySelectDialogShow = false;
    },
    changeItemPrice(index, row) {
      if (row.saleSuitId) {
        let saleSuitSumAmount = this.$jsTool.multi(
          row.saleSuitSalePrice,
          row.saleSuitQuantity
        );
        row = {
          ...row,
          saleSuitSumAmount: saleSuitSumAmount,
          saleSuitDisCountAmount: "0.00",
          saleSuitAmount: saleSuitSumAmount,
        };
      } else {
        let itemAmount = this.$jsTool.multi(row.buyingPrice, row.itemQuantity);
        row = {
          ...row,
          commodityBuyingTotalAmount: itemAmount,
          disCountAmount: 0,
          itemAmount: itemAmount,
        };
      }
      this.$nextTick(() => {
        this.changeItemAfterHandle(index, row);
      });
    },
    changeItemQuantity(index, row, value) {
      // if (row.saleSuitId) {
      //   this.itemList[index].saleSuitQuantity = 1;
      // } else {
      //   this.itemList[index].itemQuantity = 1;
      // }
      if (value == 0) {
        this.$confirm("是否移除所选商品?", "操作提醒", {
          confirmButtonText: "移除",
          cancelButtonText: "取消",
          type: "warning",
          closeOnClickModal: false,
          closeOnPressEscape: false,
          closeOnHashChange: false,
        })
          .then(() => {
            if (row.saleSuitId) {
              let selectSpecList = this.itemList.filter(
                (d) => d.saleSuitId && d.saleSuitId == row.saleSuitId
              );
              selectSpecList.forEach((item, index) => {
                let selectIndex = this.itemList.findIndex(
                  (d) =>
                    d.saleSuitId &&
                    d.saleSuitId == item.saleSuitId &&
                    d.commoditySpecId == item.commoditySpec.id
                );
                this.itemList.splice(selectIndex, 1);
              });
            } else {
              this.itemList.splice(index, 1);
            }
            this.$nextTick(() => {
              this.changeItemAfterHandle(index);
            });
          })
          .catch(() => {
            if (row.saleSuitId) {
              row.saleSuitQuantity = 1;
            } else {
              row.itemQuantity = 1;
            }
            // this.changeItemQuantity(index, row, 1);
            this.itemQuantityKey = Math.random();
          });
      } else {
        if (row.saleSuitId) {
          // 仅修改row，点击保存后再应用到单据
          let saleSuitSumAmount = this.$jsTool.multi(
            row.saleSuitSalePrice,
            value
          );
          row = {
            ...row,
            saleSuitQuantity: value,
            saleSuitSumAmount: saleSuitSumAmount,
            saleSuitDisCountAmount: "0.00",
            saleSuitAmount: saleSuitSumAmount,
          };
        } else {
          let itemAmount = this.$jsTool.multi(row.buyingPrice, value);
          row = {
            ...row,
            itemQuantity: value,
            commodityBuyingTotalAmount: itemAmount,
            disCountAmount: 0,
            itemAmount: itemAmount,
          };
        }
        this.$nextTick(() => {
          this.changeItemAfterHandle(index, row);
        });
      }
    },
    changeItemAmount(index, row) {
      if (row.saleSuitId) {
        row.saleSuitDisCountAmount = this.$jsTool.sub(
          row.saleSuitSumAmount,
          row.saleSuitAmount
        );
      } else {
        if (
          (row.itemAmount || Number(row.itemAmount) == 0) &&
          (row.commodityBuyingTotalAmount ||
            Number(row.commodityBuyingTotalAmount) == 0)
        ) {
          row.disCountAmount = this.$jsTool.sub(
            row.commodityBuyingTotalAmount,
            row.itemAmount
          );
        } else {
          row.disCountAmount = "0.00";
        }
      }
      this.changeItemAfterHandle(index, row);
    },
    changeItemAfterHandle(index, row) {
      if (!row) {
        this.selectCommodity(this.itemList);
        return;
      }
      if (row.saleSuitId) {
        let value = row.saleSuitQuantity;
        let selectSpecList = this.itemList.filter(
          (d) => d.saleSuitId && d.saleSuitId == row.saleSuitId
        );
        let totalSalePrice = this.$jsTool.multi(row.saleSuitSalePrice, value);
        let totalSalePriceD = this.$jsTool.sub(
          totalSalePrice,
          row.saleSuitDisCountAmount
        );
        let totalBuyingAmount = this.$jsTool.sum(
          selectSpecList.map((d) =>
            this.$jsTool.multi(
              d.buyingPrice,
              this.$jsTool.multi(d.saleSuitItemQuantity, value)
            )
          )
        );
        selectSpecList.forEach((item, i) => {
          let selectIndex = this.itemList.findIndex(
            (d) =>
              d.saleSuitId &&
              d.saleSuitId == item.saleSuitId &&
              d.commoditySpecId == item.commoditySpecId
          );
          let itemQuantity = Number(
            this.$jsTool.multi(value, item.saleSuitItemQuantity)
          );
          let itemTotalBuyingAmount = this.$jsTool.multi(
            item.buyingPrice,
            itemQuantity
          );
          let itemAmount = 0;
          if (i == selectSpecList.length - 1) {
            itemAmount = this.$jsTool.sub(
              totalSalePriceD,
              this.$jsTool.sum(
                this.itemList
                  .filter(
                    (d) =>
                      d.saleSuitId &&
                      d.saleSuitId == row.saleSuitId &&
                      d.commoditySpecId != item.commoditySpecId
                  )
                  .map((f) => f.itemAmount)
              )
            );
          } else {
            itemAmount = this.$jsTool.multi(
              itemTotalBuyingAmount,
              this.$jsTool.divis(totalSalePriceD, totalBuyingAmount, 8)
            );
          }
          this.itemList.splice(selectIndex, 1, {
            ...this.itemList[selectIndex],
            saleSuitQuantity: value,
            saleSuitSumAmount: totalSalePrice,
            saleSuitDisCountAmount: row.saleSuitDisCountAmount,
            saleSuitAmount: totalSalePriceD,
            itemQuantity: itemQuantity,
            commodityBuyingTotalAmount: itemTotalBuyingAmount,
            disCountAmount: this.$jsTool.sub(itemTotalBuyingAmount, itemAmount),
            itemAmount: itemAmount,
            saleSuitSalePrice: row.saleSuitSalePrice,
          });
        });
        this.selectCommodity(this.itemList);
      } else if (row.commoditySpecId) {
        this.itemList.splice(index, 1, row);
        this.selectCommodity(this.itemList);
      }
    },

    // 纸质单据有关
    paperOrderImagePreview(index) {
      document.getElementById("paperImage" + index).click();
    },
    paperOrderImageDelete(index, file) {
      this.paperOrderImageList.splice(index, 1);
      this.initPaperOrderSysFileIdList();
    },
    paperOrderImageChange(file, fileList) {
      if (file.status == "ready") {
        this.paperOrderImageList.push({
          ...file,
          url: file.url || URL.createObjectURL(file.raw),
          status: "ready",
        });
      }
      this.initPaperOrderSysFileIdList();
    },
    paperOrderImageSuccess(res, file, fileList) {
      let index = this.paperOrderImageList.findIndex((d) => d.uid == file.uid);
      if (res && res.success) {
        this.$message({
          message: "文件上传成功",
          type: "success",
        });
        this.paperOrderImageList.splice(index, 1, {
          ...this.paperOrderImageList[index],
          url: res.data.prefix + res.data.name,
          id: res.data.id,
          status: "success",
        });
      } else {
        this.$message({
          message: res.message || "文件上传失败",
          type: "error",
        });
        this.paperOrderImageList.splice(index, 1);
      }
      this.initPaperOrderSysFileIdList();
    },
    initPaperOrderSysFileIdList() {
      this.$nextTick(() => {
        this.headInfo.paperOrderSysFileIdList = this.paperOrderImageList
          .filter((d) => d.status == "success")
          .map((d) => d.id);
        this.$refs.editOrderFormRef.validateField("paperOrderSysFileIdList");
      });
    },

    // 其他费用相关
    itemOrderOtherExpenseAmountChange() {
      this.headInfo.otherExpenseAmount = this.$jsTool.sum(
        this.headInfo.orderOtherExpenseAddNewPojoList.map(
          (item) => item.itemAmount
        )
      );
      this.headInfo.commodityBuyingTotalAmount = this.$jsTool.add(
        this.$jsTool.sum(
          this.itemList.map((d) => d.commodityBuyingTotalAmount)
        ),
        this.headInfo.otherExpenseAmount
      );
      this.headInfo.orderAmount = this.$jsTool.add(
        this.headInfo.otherExpenseAmount,
        this.headInfo.commodityBuyingAmount
      );
    },
    handleHasOtherExpenseAmount(e) {
      if (e) {
        if (
          !this.headInfo.orderOtherExpenseAddNewPojoList ||
          this.headInfo.orderOtherExpenseAddNewPojoList.length == 0
        ) {
          this.headInfo.orderOtherExpenseAddNewPojoList = [
            {
              itemNo: 1,
              name: null,
              itemAmount: "0.00",
            },
          ];
        }
        this.itemOrderOtherExpenseAmountChange();
      } else {
        this.headInfo.otherExpenseAmount = "0.00";
        this.headInfo.commodityBuyingTotalAmount = this.$jsTool.add(
          this.$jsTool.sum(
            this.itemList.map((d) => d.commodityBuyingTotalAmount)
          ),
          this.headInfo.otherExpenseAmount
        );
        this.headInfo.orderAmount = this.$jsTool.add(
          this.headInfo.otherExpenseAmount,
          this.headInfo.commodityBuyingAmount
        );
      }
    },
    addOrderOtherExpenseItem(index) {
      this.headInfo.orderOtherExpenseAddNewPojoList.splice(index + 1, 0, {
        itemNo:
          this.headInfo.orderOtherExpenseAddNewPojoList[
            this.headInfo.orderOtherExpenseAddNewPojoList.length - 1
          ].itemNo + 1,
        name: null,
        itemAmount: "0.00",
      });
      this.resetOrderOtherExpenseItemNo();
    },
    deleteOrderOtherExpenseItem(index) {
      if (this.headInfo.orderOtherExpenseAddNewPojoList.length == 1) {
        this.$message({
          message: "最少保留一条其他费用信息",
          type: "error",
        });
        return;
      }
      this.headInfo.orderOtherExpenseAddNewPojoList.splice(index, 1);
      this.resetOrderOtherExpenseItemNo();
    },
    resetOrderOtherExpenseItemNo() {
      let itemNo = 1;
      this.headInfo.orderOtherExpenseAddNewPojoList
        .sort((a, b) => {
          return a.itemNo - b.itemNo;
        })
        .forEach((item) => {
          item.itemNo = itemNo;
          itemNo++;
        });
      this.itemOrderOtherExpenseAmountChange(this.itemList);
      this.otherExpenseAmountKey = Math.random();
    },

    // 其他成本相关
    itemOrderOtherCostAmountChange() {
      this.headInfo.otherCostAmount = this.$jsTool.sum(
        this.headInfo.orderOtherCostAddNewPojoList.map(
          (item) => item.itemAmount
        )
      );
      this.selectCommodity(this.itemList);
    },
    handleHasOtherCostAmount(e) {
      if (e) {
        if (
          !this.headInfo.orderOtherCostAddNewPojoList ||
          this.headInfo.orderOtherCostAddNewPojoList.length == 0
        ) {
          this.headInfo.orderOtherCostAddNewPojoList = [
            {
              itemNo: 1,
              name: null,
              itemAmount: "0.00",
            },
          ];
          this.itemOrderOtherCostAmountChange();
        }
      } else {
        this.headInfo.otherCostAmount = "0.00";
      }
    },
    addOrderOtherCostItem(index) {
      this.headInfo.orderOtherCostAddNewPojoList.splice(index + 1, 0, {
        itemNo:
          this.headInfo.orderOtherCostAddNewPojoList[
            this.headInfo.orderOtherCostAddNewPojoList.length - 1
          ].itemNo + 1,
        name: null,
        itemAmount: "0.00",
      });
      this.resetOrderOtherCostItemNo();
    },
    deleteOrderOtherCostItem(index) {
      if (this.headInfo.orderOtherCostAddNewPojoList.length == 1) {
        this.$message({
          message: "最少保留一条其他费用信息",
          type: "error",
        });
        return;
      }
      this.headInfo.orderOtherCostAddNewPojoList.splice(index, 1);
      this.resetOrderOtherCostItemNo();
    },
    resetOrderOtherCostItemNo() {
      let itemNo = 1;
      this.headInfo.orderOtherCostAddNewPojoList
        .sort((a, b) => {
          return a.itemNo - b.itemNo;
        })
        .forEach((item) => {
          item.itemNo = itemNo;
          itemNo++;
        });
      this.itemOrderOtherCostAmountChange(this.itemList);
      this.otherCostAmountKey = Math.random();
    },

    // 资金账户相关
    itemFundAccountAmountChange() {
      this.headInfo.settledAmount = this.$jsTool.sum(
        this.headInfo.fundAccountAddNewPojoList.map((item) => item.itemAmount)
      );
    },
    handleHasSettledAmount(e) {
      if (e) {
        if (
          !this.headInfo.fundAccountAddNewPojoList ||
          this.headInfo.fundAccountAddNewPojoList.length == 0
        ) {
          this.headInfo.fundAccountAddNewPojoList = [
            {
              itemNo: 1,
              fundAccountId: null,
              itemAmount: "0.00",
              remark: "",
            },
          ];
          this.$forceUpdate();
        }
        this.$nextTick(() => {
          this.$refs.editOrderFormRef.validateField(
            "collectVoucherSysFileIdList"
          );
        });
        this.itemFundAccountAmountChange();
      } else {
        this.headInfo.settledAmount = "0.00";
      }
    },
    addFundAccountItem(index) {
      this.headInfo.fundAccountAddNewPojoList.splice(index + 1, 0, {
        itemNo:
          this.headInfo.fundAccountAddNewPojoList[
            this.headInfo.fundAccountAddNewPojoList.length - 1
          ].itemNo + 1,
        fundAccountId: null,
        itemAmount: "0.00",
        remark: "",
      });
      this.resetFundAccountItemNo();
    },
    deleteFundAccountItem(index) {
      if (this.headInfo.fundAccountAddNewPojoList.length == 1) {
        this.$message({
          message: "最少保留一条现结金额信息",
          type: "error",
        });
        return;
      }
      this.headInfo.fundAccountAddNewPojoList.splice(index, 1);
      this.resetFundAccountItemNo();
    },
    resetFundAccountItemNo() {
      let itemNo = 1;
      this.headInfo.fundAccountAddNewPojoList
        .sort((a, b) => {
          return a.itemNo - b.itemNo;
        })
        .forEach((item) => {
          item.itemNo = itemNo;
          itemNo++;
        });
      this.itemFundAccountAmountChange();
    },

    // 收款凭证有关
    collectVoucherFilePreview(index) {
      document.getElementById("collectVoucherImage" + index).click();
    },
    collectVoucherFileDelete(index, file) {
      this.collectVoucherFileList.splice(index, 1);
      this.initCollectVoucherFileList();
    },
    collectVoucherFileChange(file, fileList) {
      if (file.status == "ready") {
        this.collectVoucherFileList.push({
          ...file,
          url: file.url || URL.createObjectURL(file.raw),
          status: "ready",
        });
      }
      this.initCollectVoucherFileList();
    },
    collectVoucherFileSuccess(res, file, fileList) {
      let index = this.collectVoucherFileList.findIndex(
        (d) => d.uid == file.uid
      );
      if (res && res.success) {
        this.$message({
          message: "文件上传成功",
          type: "success",
        });
        this.collectVoucherFileList.splice(index, 1, {
          ...this.collectVoucherFileList[index],
          url: res.data.prefix + res.data.name,
          id: res.data.id,
          status: "success",
        });
      } else {
        this.$message({
          message: res.message || "文件上传失败",
          type: "error",
        });
        this.collectVoucherFileList.splice(index, 1);
      }
      this.initCollectVoucherFileList();
    },
    initCollectVoucherFileList() {
      this.$nextTick(() => {
        this.headInfo.collectVoucherSysFileIdList = this.collectVoucherFileList
          .filter((d) => d.status == "success")
          .map((d) => d.id);
        this.$refs.editOrderFormRef.validateField(
          "collectVoucherSysFileIdList"
        );
      });
    },

    selectPreCollectOrder(list) {
      this.relatedPreCollectOrderList = list;
      this.headInfo.relatedPreCollectOrderIdList = list.map((item) => item.id);
    },

    // 业务员
    addSaleUser(list) {
      this.saleUserList = this.saleUserList.concat(list);
    },
    cancelSaleUser(list) {
      let cancelIdList = list.map((d) => d.id);
      this.saleUserList = this.saleUserList.filter(
        (d) => !cancelIdList.some((f) => f == d.id)
      );
    },

    // 单据金额
    changeCommodityBuyingAmount() {
      this.headInfo = {
        ...this.headInfo,
        disCountAmount: this.$jsTool.sub(
          this.maxCommodityBuyingAmount,
          this.headInfo.commodityBuyingAmount
        ),
      };
      let hasSaleSuitList = this.itemList.filter((d) => d.saleSuitId);
      let noSaleSuitList = this.itemList.filter((d) => !d.saleSuitId);
      // 先处理销售套装
      // 单据优惠比例，需要扣除套装的固定优惠
      let disCountRadio = this.$jsTool.divis(
        this.headInfo.disCountAmount,
        this.maxCommodityBuyingAmount,
        8
      );
      if (hasSaleSuitList && hasSaleSuitList.length > 0) {
        let hasSaleSuitArr = this.$jsTool.groupByV(
          hasSaleSuitList,
          "saleSuitId"
        );
        hasSaleSuitArr.forEach((saleSuitItem, saleSuitIndex) => {
          // 规格总售价
          let specCommodityBuyingTotalAmountSum = this.$jsTool.sum(
            saleSuitItem.map((d) => d.commodityBuyingTotalAmount)
          );
          // 销售套装售价
          let saleSuitDisCountAmount = 0;
          if (
            saleSuitIndex == hasSaleSuitArr.length - 1 &&
            (!noSaleSuitList || noSaleSuitList.length == 0)
          ) {
            saleSuitDisCountAmount = this.$jsTool.sub(
              this.headInfo.disCountAmount,
              this.$jsTool.sum(
                this.$jsTool
                  .groupByV(
                    this.itemList.filter(
                      (d) =>
                        d.saleSuitId &&
                        d.saleSuitId != saleSuitItem[0].saleSuitId
                    ),
                    "saleSuitId"
                  )
                  .map((d) =>
                    this.$jsTool.add(
                      d[0].saleSuitDisCountAmount,
                      this.$jsTool.sub(
                        this.$jsTool.sum(
                          d.map((h) => h.commodityBuyingTotalAmount)
                        ),
                        d[0].saleSuitSumAmount
                      )
                    )
                  )
              )
            );
          } else {
            saleSuitDisCountAmount = this.$jsTool.add(
              this.$jsTool.sub(
                specCommodityBuyingTotalAmountSum,
                saleSuitItem[0].saleSuitSumAmount
              ),
              this.$jsTool.multi(
                disCountRadio,
                saleSuitItem[0].saleSuitSumAmount,
                8
              )
            );
          }
          saleSuitItem.forEach((item, index) => {
            let curIndex = this.itemList.findIndex(
              (d) =>
                d.saleSuitId &&
                d.saleSuitId == item.saleSuitId &&
                d.commoditySpecId == item.commoditySpecId
            );
            let disCountAmount = 0;
            if (index == saleSuitItem.length - 1) {
              disCountAmount = this.$jsTool.sub(
                saleSuitDisCountAmount,
                this.$jsTool.sum(
                  this.itemList
                    .filter(
                      (d) =>
                        d.saleSuitId &&
                        d.saleSuitId == item.saleSuitId &&
                        d.commoditySpecId != item.commoditySpecId
                    )
                    .map((f) => f.disCountAmount)
                )
              );
            } else {
              disCountAmount = this.$jsTool.multi(
                this.$jsTool.divis(
                  item.commodityBuyingTotalAmount,
                  specCommodityBuyingTotalAmountSum,
                  8
                ),
                saleSuitDisCountAmount
              );
            }
            let saleSuitDisCountAmount2 = this.$jsTool.sub(
              saleSuitDisCountAmount,
              this.$jsTool.sub(
                specCommodityBuyingTotalAmountSum,
                this.itemList[curIndex].saleSuitSumAmount
              )
            );
            this.itemList.splice(curIndex, 1, {
              ...this.itemList[curIndex],
              saleSuitDisCountAmount: saleSuitDisCountAmount2,
              saleSuitAmount: this.$jsTool.sub(
                this.itemList[curIndex].saleSuitSumAmount,
                saleSuitDisCountAmount2
              ),
              itemAmount: this.$jsTool.sub(
                this.itemList[curIndex].commodityBuyingTotalAmount,
                disCountAmount
              ),
              disCountAmount: disCountAmount,
            });
          });
        });
      }

      if (noSaleSuitList && noSaleSuitList.length > 0) {
        noSaleSuitList.forEach((item, index) => {
          let curIndex = this.itemList.findIndex(
            (d) => !d.saleSuitId && d.commoditySpecId == item.commoditySpecId
          );
          let disCountAmount = 0;
          if (index == noSaleSuitList.length - 1) {
            disCountAmount = this.$jsTool.sub(
              this.headInfo.disCountAmount,
              this.$jsTool.sum(
                this.itemList
                  .filter(
                    (d) =>
                      d.saleSuitId ||
                      (!d.saleSuitId &&
                        d.commoditySpecId != item.commoditySpecId)
                  )
                  .map((f) => f.disCountAmount)
              )
            );
          } else {
            disCountAmount = this.$jsTool.multi(
              disCountRadio,
              item.commodityBuyingTotalAmount
            );
          }
          this.itemList.splice(curIndex, 1, {
            ...this.itemList[curIndex],
            itemAmount: this.$jsTool.sub(
              item.commodityBuyingTotalAmount,
              disCountAmount
            ),
            disCountAmount: disCountAmount,
          });
        });
      }
      this.selectCommodity(this.itemList);
    },

    async getOrderInfo(args) {
      let res = await this.$api.saleOrder_findVoById(this.orderId, {
        showLoading: true,
        loadingParam: {
          target: "#editDialog > *",
          lock: true,
        },
        ...args,
      });
      if (res && res.success) {
        this.headInfo = {
          ...res.data.headVo,
          orderOtherExpenseAddNewPojoList:
            res.data.headVo.orderOtherExpenseList,
          orderOtherCostAddNewPojoList: res.data.headVo.orderOtherCostList,
          fundAccountAddNewPojoList: res.data.headVo.fundAccountList,
          saleUserIdList: res.data.headVo.saleUserList.map((d) => d.userId),
          relatedPreCollectOrderIdList:
            res.data.headVo.relatedPreCollectOrderList.map(
              (d) => d.preCollectOrderId
            ),
          collectVoucherSysFileIdList:
            res.data.headVo.collectVoucherImageList.map((d) => d.sysFile.id),
          collectRemark: res.data.headVo.collectRemark || "",
          extFieldValueAddNewPojoList: [],
          paperOrderSysFileIdList: res.data.headVo.paperOrderImageList.map(
            (d) => d.sysFile.id
          ),
        };

        let commodityIdList = res.data.itemList.map((d) => d.commodityId);
        let findCommodityVoRes = await this.$api.commodity_findVoByIdIn(
          commodityIdList,
          {
            showLoading: true,
            loadingParam: {
              target: "#editDialog > *",
              lock: true,
            },
          }
        );
        let commodityVoList = [];
        if (findCommodityVoRes && findCommodityVoRes.success) {
          commodityVoList = findCommodityVoRes.data;
        }

        this.itemList = res.data.itemList.map((d) => {
          let commodityVo = commodityVoList.filter(
            (f) => f.commodity.id == d.commodityId
          )[0];
          let item = d;
          item.commodity = commodityVo.commodity;
          item.commoditySpec = commodityVo.commoditySpecList.filter(
            (f) => f.id == d.commoditySpecId
          )[0];
          item.tips =
            typeof d.originalBuyingPrice == "number" &&
            typeof d.lastBuyingPrice == "number" &&
            d.originalBuyingPrice != d.lastBuyingPrice
              ? "原零售价" +
                Number(d.originalBuyingPrice).toFixed(2) +
                ",客户上次购买价" +
                Number(d.lastBuyingPrice).toFixed(2)
              : "";
          return item;
        });
        this.customer = res.data.headVo.customer;
        this.saleUserList = res.data.headVo.saleUserList.map((d) => d.user);
        this.relatedPreCollectOrderList =
          res.data.headVo.relatedPreCollectOrderList.map(
            (d) => d.preCollectOrder
          );
        if (
          res.data.headVo.fundAccountList &&
          res.data.headVo.fundAccountList.length > 0
        ) {
          this.hasSettledAmount = true;
        }
        if (
          res.data.headVo.orderOtherExpenseList &&
          res.data.headVo.orderOtherExpenseList.length > 0
        ) {
          this.hasOtherExpenseAmount = true;
        }
        if (
          res.data.headVo.orderOtherCostList &&
          res.data.headVo.orderOtherCostList.length > 0
        ) {
          this.hasOtherCostAmount = true;
        }

        this.paperOrderImageList = res.data.headVo.paperOrderImageList.map(
          (item) => {
            return {
              imageName: item.sysFile.name,
              id: item.sysFile.id,
              message: "已有图片",
              status: "success",
              thumb: item.sysFile.prefix + item.sysFile.name,
              type: "image",
              url: item.sysFile.prefix + item.sysFile.name,
            };
          }
        );

        this.collectVoucherFileList =
          res.data.headVo.collectVoucherImageList.map((item) => {
            return {
              imageName: item.sysFile.name,
              id: item.sysFile.id,
              message: "已有图片",
              status: "success",
              thumb: item.sysFile.prefix + item.sysFile.name,
              type: "image",
              url: item.sysFile.prefix + item.sysFile.name,
            };
          });

        // 拓展字段
        let extFieldValueAddNewPojoList = [];
        for (let extFieldItem of this.extFieldList) {
          let value = extFieldItem.value;
          if (
            res.data.headVo.extFieldValueList &&
            res.data.headVo.extFieldValueList.length > 0
          ) {
            let extFieldValueAddNewIndex =
              res.data.headVo.extFieldValueList.findIndex(
                (d) => d.code == extFieldItem.code
              );
            let extFieldValueAddNewItem =
              res.data.headVo.extFieldValueList[extFieldValueAddNewIndex];
            if (extFieldValueAddNewIndex > -1) {
              value =
                extFieldItem.extFieldTypeEnum ==
                  extFieldValueAddNewItem.extFieldTypeEnum.Name ||
                extFieldItem.extFieldTypeEnum ==
                  extFieldValueAddNewItem.extFieldTypeEnum
                  ? extFieldValueAddNewItem.value
                  : null;
              if (
                extFieldItem.extFieldTypeEnum == "Checkbox" ||
                extFieldItem.extFieldTypeEnum.Name == "Checkbox"
              ) {
                if (value) {
                  if (typeof value == "string") {
                    value = value.split(",");
                  }
                } else {
                  value = [];
                }
              }
            }
          }
          extFieldValueAddNewPojoList.push({
            ...JSON.parse(JSON.stringify(extFieldItem)),
            value: value,
          });
        }
        this.headInfo.extFieldValueAddNewPojoList = extFieldValueAddNewPojoList;

        this.$nextTick(() => {
          setTimeout(() => {
            if (
              this.hasSettledAmount ||
              this.hasOtherExpenseAmount ||
              this.hasOtherCostAmount
            ) {
              this.$forceUpdate();
            }
          }, 200);
        });
      }
    },

    edit(submit) {
      if (!this.hasSettledAmount) {
        this.headInfo.settledAmount = "0.00";
        this.headInfo.fundAccountAddNewPojoList = [];
        this.headInfo.paperOrderSysFileIdList = [];
        this.headInfo.collectVoucherSysFileIdList = [];
        this.headInfo.collectRemark = "";
      } else {
        if (
          this.paperOrderImageList &&
          this.paperOrderImageList.length > 0 &&
          this.paperOrderImageList.filter((d) => d.status == "success").length >
            0
        ) {
          this.headInfo.paperOrderSysFileIdList = this.paperOrderImageList
            .filter((d) => d.status == "success")
            .map((d) => d.id);
        }
        if (
          this.collectVoucherFileList &&
          this.collectVoucherFileList.length > 0 &&
          this.collectVoucherFileList.filter((d) => d.status == "success")
            .length > 0
        ) {
          this.headInfo.collectVoucherSysFileIdList =
            this.collectVoucherFileList
              .filter((d) => d.status == "success")
              .map((d) => d.id);
        }
      }
      if (!this.hasOtherExpenseAmount) {
        this.headInfo.otherExpenseAmount = "0.00";
        this.headInfo.orderOtherExpenseAddNewPojoList = [];
      }
      if (!this.hasOtherCostAmount) {
        this.headInfo.otherCostAmount = "0.00";
        this.headInfo.orderOtherCostAddNewPojoList = [];
      }
      //  校验拓展字段是否填写
      for (let item of this.headInfo.extFieldValueAddNewPojoList) {
        if (item.requiredMark && item.visible && item.value == null) {
          this.$message({
            message: "请完善拓展字段 " + item.label,
            type: "error",
          });
          return;
        }
      }
      let extFieldValueAddNewPojoList = JSON.parse(
        JSON.stringify(
          this.headInfo.extFieldValueAddNewPojoList.filter((d) => d.visible)
        )
      );
      for (let item of extFieldValueAddNewPojoList) {
        if (item.extFieldTypeEnum == "Checkbox" && item.value) {
          item.value = item.value.toString();
        }
        item.extFieldId = item.id;
      }
      this.$refs.editOrderFormRef.validate(async (valid) => {
        if (!valid) {
          return;
        }
        let requestRes = this.headInfo.id
          ? submit
            ? await this.$api.saleOrder_updateAndSubmit(
                {
                  headUpdatePojo: {
                    ...this.headInfo,
                    extFieldValueAddNewPojoList,
                  },
                  itemAddNewPojoList: this.itemList,
                },
                {
                  showLoading: true,
                  loadingParam: {
                    target: "#editDialog > *",
                    lock: true,
                    text: "修改中...",
                  },
                }
              )
            : await this.$api.saleOrder_update(
                {
                  headUpdatePojo: {
                    ...this.headInfo,
                    extFieldValueAddNewPojoList,
                  },
                  itemAddNewPojoList: this.itemList,
                },
                {
                  showLoading: true,
                  loadingParam: {
                    target: "#editDialog > *",
                    lock: true,
                    text: "修改中...",
                  },
                }
              )
          : submit
          ? await this.$api.saleOrder_saveIntoDraftAndSubmit(
              {
                headAddNewPojo: {
                  ...this.headInfo,
                  extFieldValueAddNewPojoList,
                },
                itemAddNewPojoList: this.itemList,
              },
              {
                showLoading: true,
                loadingParam: {
                  target: "#editDialog > *",
                  lock: true,
                  text: "新增中...",
                },
              }
            )
          : await this.$api.saleOrder_saveIntoDraft(
              {
                headAddNewPojo: {
                  ...this.headInfo,
                  extFieldValueAddNewPojoList,
                },
                itemAddNewPojoList: this.itemList,
              },
              {
                showLoading: true,
                loadingParam: {
                  target: "#editDialog > *",
                  lock: true,
                  text: "新增中...",
                },
              }
            );
        if (requestRes && requestRes.success) {
          this.close(true);
        }
      });
    },
    close(flush) {
      this.$emit("close", flush);
    },
  },
};
</script>

<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// src/components/order/SaleOrderEditDialog.vue